<template>
    <div id="app">
        <transition>
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </transition>
    </div>
</template>a

<script>
  export default {
    name: 'App',
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue